<template>
  <b-modal
      id="edit-pay-rate"
      ref="edit-pay-rate"
      modal-class="pay-rate"
      size="sm-size"
      centered
      hide-footer
      hide-header
      @hide="close"
  >
    <div class="modal-head">
      <h2 class="modal-title">
        {{ label.get('edit_pay_rate') }}
      </h2>
    </div>
    <div class="content-wrapper">
      <div class="form-container">
        <div class="d-flex justify-content-between align-items-center">
          <div class="hourly-rate">
            <h5 class="section-title">
              {{label.get('hourly-rate')}}
            </h5>
            <div
                class="custom-input-wrapper"
            >
              <span class="currency">$</span>
              <input
                  v-model="item.hourly_rate"
                  type="number"
                  maxlength="3"
                  step="0.01"
                  value="0.00"
                  placeholder="0.00"
                  @input="onHourlyRateInput"
                  class="atto-input"
              >
              <span class="hour">/h</span>
            </div>
          </div>
          <div class="effective-from">
            <h5 class="section-title">
              {{label.get('effective_from')}}
            </h5>
            <div class="field-details">
              <simple-datepicker-component
                  :initial-date="item.effective_from"
                  :date-format="'MMMM D, YYYY'"
                  :close-on-select="true"
                  @onDateSelected="onDateSelected"
              />
            </div>
          </div>
        </div>
        <div class="error-wrapper">
            <span
                v-if="hourlyRateError && !$v.item.hourly_rate.required"
                class="error-message"
            >
              {{label.get('hourly_rate_is_required')}}
            </span>
          <span
              v-if="duplicateDateError"
              class="error-message"
          >
              {{label.get('duplicate_effective_from_error_message')}}
            </span>
        </div>
        </div>
      </div>
    <div class="modal-footer">
      <div class="form-buttons">
        <button
            class="atto-btn cancel"
            @click="close"
        >
          {{ label.get('cancel') }}
        </button>
        <button
            class="atto-btn submit"
            :disabled="disabledSaveButton"
            @click="saveChanges"
        >
          {{ label.get('save_changes') }}
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
  import PayRateService from "../../services/PayRateService";
  import SimpleDatepickerComponent from "../../../../../shared/components/SimpleDatepickerComponent";
  import {required, maxLength} from 'vuelidate/lib/validators';

  export default {
    name: "EditPayRateComponent",
    components: {SimpleDatepickerComponent},
    props: {
      payRate: {
        type: Object,
        default: () => {
          return {};
        }
      },
      payRates: {
        type: Array,
        default: []
      }
    },
    validations: {
      item: {
        hourly_rate: {
          required,
          maxLength: maxLength(6)
        }
      }
    },
    data() {
      return {
        disabledSaveButton: false,
        duplicateDateError: false,
        list: Object.assign([], this.payRates),
        item: Object.assign({}, this.payRate),
        hourlyRateError: false,
      }
    },
    mounted() {
      document.body.appendChild(this.$el);
      this.$refs['edit-pay-rate'].show();
    },
    methods: {
      close() {
        this.$root.$emit('hideEditPayRate');
      },
      onDateSelected(date) {
        if (date === undefined || date === null) {
          return;
        }
        this.item.effective_from = date;
      },
      onHourlyRateInput(event) {
        const inputElem = event.currentTarget;
        if(inputElem.value === "") {
          return;
        }
        const value = parseFloat(inputElem.value).toFixed(2);
        const [numValue, decimalValue] = value.split('.');

        if (parseInt(numValue) > 999) {
          this.payRate.hourly_rate = numValue.slice(0, 3) + '.' + decimalValue;
        } else if (numValue.length > inputElem.maxLength) {
          this.payRate.hourly_rate = inputElem.value.slice(0, inputElem.maxLength);
        }
      },
      saveChanges() {
        this.hourlyRateError = false;
        this.duplicateDateError = false;

        this.$v.item.hourly_rate.$touch();
        if (this.$v.item.hourly_rate.$invalid) {
          this.hourlyRateError = true;
          return false;
        }
        debugger;
        this.list = this.list.filter((x) => x.id !== this.item.id);
        this.list.push(this.item);
        if(this.checkForDuplicateDates(this.list)) {
          this.duplicateDateError = true;
          return false;
        }

        this.disabledSaveButton = true;
        PayRateService.update(this.item.id, this.item).then((result) => {
          this.payRate.hourly_rate = this.item.hourly_rate;
          this.payRate.effective_from = this.item.effective_from;
          this.$root.$emit('hideEditPayRate', result);
        }).catch((error) => {
          this.disabledSaveButton = false;
        });
      },
      checkForDuplicateDates(values) {
        const valueArr = values.map(function(item){ return item.effective_from });
        return valueArr.some(function(item, idx){
          return valueArr.indexOf(item) !== idx;
        });
      }
    }
  }
</script>

<style scoped>

</style>